import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TextField } from '@mui/material';
import { toast } from 'react-toastify';

import TopSection from '../../LT/TopSection'
import { DataDetails } from './DataDetails'
import { Loader } from '../../../components/common/Loader';
import ButtonComponent from '../../../components/common/button/Button';
import { fetchPriceMemoMaintenanceData } from '../../../redux/actions/PriceMemoMaintenance';
import { deletePriceMemoMaintenanceEndpoint, priceMemoMaintenanceDataEndpoint, publishPriceMemoMaintenanceEndpoint, savePriceMemoMaintenanceEndpoint } from '../../../common/endpoints';
import { savePriceMemoMaintenanceData } from '../../../redux/actions/PriceMemoMaintenance/SavePriceMemo';
import Modal from '../../../components/common/modal/Modal';
import Upload from './Upload';
import { publishPriceMemoData } from '../../../redux/actions/PriceMemoMaintenance/PublishPriceMemo';
import { deletePriceMemoData } from '../../../redux/actions/PriceMemoMaintenance/DeletePriceMemo';

const ModalFooter = (props) => {
  return (
    <div className="footer-btn-wrapper">
      <ButtonComponent
        maxWidth="170px"
        label="Cancel"
        bgColor="white"
        color="black"
        onClick={props.onClosePopup}
      />
      <ButtonComponent
        maxWidth="170px"
        label="Add"
        bgColor="black"
        color="white"
        onClick={props.onSubmit}
        disabled={props.disabled}
      />
    </div>
  );
};

export const PriceMemoManagement = () => {
  const dispatch = useDispatch();
  const procurementDivisionType = useSelector((state) => state?.userCardType?.procurementDivisionType);
  const [loading, setLoading] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [btnDisabled, setIsBtnDisabled] = useState(true);
  const [openAddLineBox, setOpenAddLineBox] = useState(false);
  const [lineItemValue, setLineItemValue] = useState("");
  const pmMaintenanceDataList = useSelector((state) => state?.PriceMemoMaintenanceSlice);
  const [validationErrorMessage, setValidationErrorMessage] = useState('');
  const [openValidationErrorPopup, setOpenValidationErrorPopup] = useState(false);
  const [openSavedPopup, setOpenSavedPopup] = useState(false);
  const [openPublishPopup, setOpenPublishPopup] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [disablePublishBtn, setDisablePublishBtn] = useState(true);
  const gridApiRef = useRef(null);
  const tempSeqIdRef = useRef(-1);

  const userName = localStorage.getItem("data");
  const name = localStorage.getItem("userName");
  const region = localStorage.getItem("CDRegion");
  const CdRole = localStorage.getItem("CDRole");

  const cleanUsername = (name) => {
    return name.replace(/\s*\[C\]/, ""); // Removes "[C]" with optional leading space
  };
  

  const onSelectionChanged = (params) => {
    const selectedRowsOnCurrentPage = [];
    params?.api?.forEachNodeAfterFilterAndSort((node) => {
      if (node.isSelected()) {
        selectedRowsOnCurrentPage.push(node.data);
      }
    });

    setRowsData(selectedRowsOnCurrentPage);

    const hasReadyToPublish = selectedRowsOnCurrentPage.length > 0 && selectedRowsOnCurrentPage.every((row) =>
      row?.status?.toLowerCase() === 'ready to publish'
    );

    const hasMfiGroup = selectedRowsOnCurrentPage.some((row) =>
      row?.procurementGroup?.toUpperCase() === 'MFI'
    );

    setDisablePublishBtn(!hasReadyToPublish || hasMfiGroup);

    selectedRowsOnCurrentPage.length
      ? setIsBtnDisabled(false)
      : setIsBtnDisabled(true);
  };

  const rowSelection = useMemo(() => {
    return {
      mode: "multiRow",
      isRowSelectable: (rowNode) =>
        rowNode.data
          ? true
          : false,
    };
  }, []);

  const handleCellValueChange = async (params) => {
    if (rowsData.some(row => row?.sequenceId === params?.data?.sequenceId)) {
      const updatedSelectedRows = rowsData?.map(row =>
        row?.sequenceId === params?.data?.sequenceId ? params?.data : row
      );
      setRowsData(updatedSelectedRows);
    }
  };

  const getMandatoryFieldsForRowPackg = () => {
    let fields = [
      { field: 'year', title: 'Year' },
      { field: 'plantId', title: 'Plant Id' },
      { field: 'plantName', title: 'Plant Name' },
      { field: 'supplierMaterialNumber', title: 'Supplier Pin' },
      { field: 'material', title: 'Material Number' },
      { field: 'materialDescription', title: 'Material Description' },
      { field: 'vendorNumber', title: 'Vendor Number' },
      { field: 'vendorName', title: 'Vendor Name' },
      { field: 'supplierLocation', title: 'Location Name' },
      { field: 'validFrom', title: 'Valid From' },
      { field: 'validTo', title: 'Valid To' },
      { field: 'netPrice', title: 'Net Price' },
      { field: 'currency', title: 'Currency' },
      { field: 'uom', title: 'UOM' },
      { field: 'perQty', title: 'Per Qty' },
      { field: 'incoterms', title: 'Incoterms' },
      { field: 'namedPlace', title: 'Named Place' },
      { field: 'paymentTerms', title: 'Pay Terms' },
      { field: 'leadTime', title: 'Lead Time' },
    ];
    return fields;
  };

  const getMandatoryFieldsForRowCepg = () => {
    let fields = [
      { field: 'plantId', title: 'Plant ID' },
      { field: 'plantName', title: 'Plant Name' },
      { field: 'material', title: 'Material Number' },
      { field: 'materialDescription', title: 'Material Description' },
      { field: 'vendorName', title: 'Supplier Name' },
      { field: 'vendorNumber', title: 'Supplier Number' },
      { field: 'netPrice', title: 'Price' },
      { field: 'currency', title: 'Currency' },
      { field: 'uom', title: 'UOM' },
      { field: 'incoterms', title: 'Incoterms' },
      { field: 'namedPlace', title: 'Named Place' },
      { field: 'validFrom', title: 'Valid From' },
      { field: 'validTo', title: 'Valid To' },
      { field: 'paymentTerms', title: 'Payment Term' },
      { field: 'leadTime', title: 'Lead Time' },
      { field: 'picassoFacility', title: 'Picasso Facility' },
    ];
    return fields;
  };

  const getNewLineTemplate = () => {
    const normalizedRole = (CdRole || "").trim().toLowerCase();

    if (normalizedRole === "price memo owner (packaging)") {
      return {
        sequenceId: tempSeqIdRef.current,
        runOutputSeqId: null,
        status: "",
        lastUpdateTimestamp: "",
        year: "",
        plantId: "",
        division: "",
        plantName: "",
        supplierMaterialNumber: "",
        materialType: "",
        material: "",
        materialDescription: "",
        vendorNumber: "",
        vendorName: "",
        supplierLocation: "",
        managerName: "",
        supplierDescription: "",
        validFrom: "",
        validTo: "",
        fromQty: "",
        toQty: "",
        netPrice: "",
        currency: "",
        uom: "",
        perQty: "",
        incoterms: '',
        namedPlace: "",
        comments: "",
        paymentTermsDescription: "",
        paymentTerms: "",
        targetQuantity: "",
        allocationNotes: "",
        leadTime: "",
        lastChange: "",
        reasonForChange: "",
        contractUpdated: "",
        userId: "",
        userName: "",
        errors: "",
      };
    }

    if (normalizedRole === "price memo owner (cepg)") {
      return {
        sequenceId: tempSeqIdRef.current,
        runOutputSeqId: null,
        status: "",
        GMPLead: "",
        procurementGroup: "",
        year: null,
        division: "",
        plantId: "",
        plantName: "",
        material: "",
        materialDescription: "",
        sCode: "",
        changeDate: "",
        vendorNumber: "",
        vendorName: "",
        manager: "",
        packSize: "",
        netPrice: "",
        currency: "",
        uom: "",
        incoterms: '',
        namedPlace: "",
        fromQty: "",
        toQty: "",
        validFrom: "",
        validTo: "",
        paymentTerms: "",
        leadTime: "",
        targetQuantity: "",
        systemDateStamp: "",
        comments: "",
        lastUpdateTimestamp: "",
        allocationNotes: "",
        picassoFacility: "",
        userId: "",
        userName: "",
        errors: "",
      };
    }
  };

  const handleAddLine = () => {
    if (!gridApiRef.current) return;

    const count = parseInt(lineItemValue, 10);
    if (isNaN(count) || count <= 0) {
      return;
    }

    const newRows = [];
    for (let i = 0; i < count; i++) {
      newRows.push(getNewLineTemplate());
      tempSeqIdRef.current -= 1;
    }

    gridApiRef.current.applyTransaction({ add: newRows, addIndex: 0 });

    // reset modal state
    setLineItemValue("");
    setOpenAddLineBox(false);
  };

  const getPmOwnerData = useCallback( async () => {
    setLoading(true);
    try {
      const response = await dispatch(
          fetchPriceMemoMaintenanceData({
            dynamicEndpoint: `${priceMemoMaintenanceDataEndpoint}/${procurementDivisionType.toLowerCase()}/getPriceMemo?userName=${cleanUsername(userName)}&region=${region}`,
          })
        );
        if (response?.meta?.requestStatus === 'fulfilled') {
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(`${response?.payload?.errorMessage}`);
          console.error('Failed to fetch data:', response.error);
        }
    } catch(error){
      setLoading(false);
      toast.error("Error fetching Price Memo Maintenance data");
      console.error("Error fetching Price Memo Maintenance data:", error);
    }
    
  }, [dispatch, procurementDivisionType, userName, region]);

  const handleFindEmptyMandatoryFields = async (event) => {
    const emptyFieldsPerRow = rowsData.map(row => {
      const mandatoryFields = procurementDivisionType === "Packaging" ? getMandatoryFieldsForRowPackg() : getMandatoryFieldsForRowCepg();
      const emptyFields = mandatoryFields.filter(({ field }) => !row[field] || row[field] === "");
      return { sequenceId: row.sequenceId, emptyFields };
    }).filter(row => row.emptyFields.length > 0);

    if (emptyFieldsPerRow.length > 0) {
      const errorMessage = `Mandatory fields are empty. Please check the highlighted fields in red and try again!`
      setValidationErrorMessage(errorMessage);
      setOpenValidationErrorPopup(true);
      return;
    } else if (emptyFieldsPerRow?.length === 0) {
      if (event.target.innerHTML === 'Publish') {
        setOpenPublishPopup(true);
      }
    }
  }

  const handleSavePM = useCallback( async () => {
    setLoading(true);
    setOpenSavedPopup(false);
    try {
      const response = await dispatch(
          savePriceMemoMaintenanceData({
            dynamicEndpoint: `${savePriceMemoMaintenanceEndpoint}/${procurementDivisionType.toLowerCase()}/savePriceMemo?userName=${cleanUsername(name)}&userId=${userName}&region=${region}`,
            data: rowsData,
          })
        );
        if (response?.meta?.requestStatus === 'fulfilled') {
          setLoading(false);
          toast.success("Price Memo Maintenance data saved successfully!");
          getPmOwnerData();
          setRowsData([]);
          setIsBtnDisabled(true);
        } else {
          setLoading(false);
          toast.error("something went wrong, please try again later");
          setIsBtnDisabled(true);
          console.error('Failed to fetch data:', response.error);
        }
    } catch(error){
      setLoading(false);
      toast.error("Error saving Price Memo Maintenance data");
      console.error("Error saving Price Memo Maintenance data:", error);
    }
    
  }, [dispatch, procurementDivisionType, userName, name, rowsData, getPmOwnerData, region]);

  useEffect(() => {
      getPmOwnerData();
    }, [getPmOwnerData]);

  const handleLineItemChange = (event) => {
    let val = event.target.value;
    // only allow positive integers or empty
    if (val === "" || /^[0-9]*$/.test(val)) {
      // enforce max of 20
      if (val !== "") {
        const num = parseInt(val, 10);
        if (num > 20) {
          val = "20";
        }
      }
      setLineItemValue(val);
    }
  }

  const publishPriceMemoHandler = async () => {
    setLoading(true);
    setOpenPublishPopup(false);
    try {
      const response = await dispatch(
          publishPriceMemoData({
            dynamicEndpoint: `${publishPriceMemoMaintenanceEndpoint}/${procurementDivisionType.toLowerCase()}/publish?userName=${cleanUsername(name)}&userId=${userName}&region=${region}`,
            data: rowsData,
          })
        );
        if (response?.meta?.requestStatus === 'fulfilled') {
          setLoading(false);
          toast.success("Price Memo submission successful!");
          getPmOwnerData();
          setRowsData([]);
          setIsBtnDisabled(true);
        } else {
          setLoading(false);
          setIsBtnDisabled(true);
          toast.error("something went wrong, please try again later");
        }
    } catch(error){
      setLoading(false);
      toast.error("Error publishing Price Memo");
    }
  }

  const deletePriceMemoHandler = async () => {
    setLoading(true);
    setOpenDeletePopup(false);
    try {
      const response = await dispatch(
          deletePriceMemoData({
            dynamicEndpoint: `${procurementDivisionType.toLowerCase() === 'packaging' ? `${deletePriceMemoMaintenanceEndpoint}/${procurementDivisionType.toLowerCase()}/delete?userName=${cleanUsername(name)}&userId=${userName}&region=${region}` : `${deletePriceMemoMaintenanceEndpoint}/${procurementDivisionType.toLowerCase()}/delete?userName=${cleanUsername(name)}&userId=${userName}`}`,
            data: rowsData,
          })
        );
        if (response?.meta?.requestStatus === 'fulfilled') {
          setLoading(false);
          toast.success(response?.payload, {
            autoClose: 2000,
          });
          getPmOwnerData();
          setRowsData([]);
          setIsBtnDisabled(true);
        } else {
          setLoading(false);
          setIsBtnDisabled(true);
          toast.error("Something went wrong, please try again later", {
            autoClose: 2000,
          });
        }
    } catch(error){
      setLoading(false);
      toast.error("Error publishing Price Memo");
    }
  }

  const handleCloseAddLinePopup = () => {
    setOpenAddLineBox(false);
    setLineItemValue("");
  }

  return (
    <>
      <TopSection
        labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "Price Memo Management" },
        ]}
        hideHeader={true}
        headerName={"Price Memo Management"}
        />
        {
          loading ? <Loader />
          :
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Upload 
            setLoading={setLoading}
          />
        </Grid>
        <Grid item xs={12}>
          <div className="priceMemo_main">
            {loading ? (
              <Loader />
            ) : !pmMaintenanceDataList?.data ? (
              <div style={{ textAlign: "center", fontWeight: "bold" }}>
                No record found
              </div>
            ) : (
              <div className="priceMemo_dataTable">
                <DataDetails
                  onSelectionChanged={onSelectionChanged}
                  btnDisabled={btnDisabled}
                  data={pmMaintenanceDataList?.data}
                  rowSelection={rowSelection}
                  handleCellValueChange={handleCellValueChange}
                  gridApiRef={gridApiRef}
                  setRowsData={setTotalRecords}
                />
                 <div style={{ margin: "10px 0px 10px 10px", fontWeight: "bold" }}>
                Total Records: {totalRecords > 0 ? totalRecords : (pmMaintenanceDataList?.data?.packagingPMMaintenanceDTOList?.length || pmMaintenanceDataList?.data?.cepgPMMaintenanceDTOList?.length || 0)}
              </div>
                <div
                  style={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "360px",
                    }}
                  >
                    <ButtonComponent
                      label="Add Line"
                      bgColor="#000"
                      color="#fff"
                      onClick={() => setOpenAddLineBox(true)}
                    />
                    <ButtonComponent
                      label="Save Draft"
                      bgColor="#000"
                      color="#fff"
                      onClick={() =>  setOpenSavedPopup(true)}
                      disabled={btnDisabled}
                    />
                    <ButtonComponent
                      label="Delete"
                      bgColor="#000"
                      color="#fff"
                      onClick={() =>  setOpenDeletePopup(true)}
                      disabled={btnDisabled}
                    />
                    <ButtonComponent
                      label="Publish"
                      bgColor="#000"
                      color="#fff"
                      disabled={disablePublishBtn}
                      onClick={handleFindEmptyMandatoryFields}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Grid>
      </Grid> 
        }
      <Modal
        open={openAddLineBox}
        handleClose={handleCloseAddLinePopup}
        title="Add Line Items"
        content={
          <div>
            <p style={{marginTop: '0'}}>How many line items would you like to add?</p>
            <TextField
              id="lineItems"
              label="No. of Lines (Max 20)"
              type="number"
              name="lineItems"
              variant="outlined"
              size='small'
              onChange={handleLineItemChange}
              value={lineItemValue}
              required
              inputProps={{ min: 1}}
            />
          </div>
        }
        action={
          <ModalFooter
            onClosePopup={handleCloseAddLinePopup}
            onSubmit={handleAddLine}
            disabled={
              !(parseInt(lineItemValue, 10) > 0) ||
              parseInt(lineItemValue, 10) > 20
            }
          />
        }
      />
      { openValidationErrorPopup &&
      <Modal
        open={openValidationErrorPopup}
        handleClose={() => setOpenValidationErrorPopup(false)}
        title="Validation Error"
        content={
          <div>
            <p>{validationErrorMessage}</p>
          </div>
        }
        action={
          <ButtonComponent
            maxWidth="170px"
            label="Close"
            bgColor="white"
            color="black"
            onClick={() => setOpenValidationErrorPopup(false)}
          />
        }
      />}
      { openSavedPopup &&
      <Modal
        open={openSavedPopup}
        handleClose={() => setOpenSavedPopup(false)}
        title="Save as Draft"
        content={
          <div>
            <p>{rowsData.length > 1 ? `Are you sure you want to save these line items as a draft?` : `Are you sure you want to save this line item as a draft?`}</p>
          </div>
        }
        action={
          <>
          <ButtonComponent
            maxWidth="170px"
            label="No"
            bgColor="white"
            color="black"
            onClick={() => setOpenSavedPopup(false)}
          />
          <ButtonComponent
            maxWidth="170px"
            label="Yes"
            bgColor="black"
            color="white"
            onClick={handleSavePM}
          />
          </>
        }
      />}
      { openPublishPopup &&
      <Modal
        open={openPublishPopup}
        handleClose={() => setOpenPublishPopup(false)}
        title="Publish Price Memo"
        content={
          <div>
            <p>{rowsData?.length > 1 ? `Are you sure you want to publish these Price Memos?` : `Are you sure you want to publish this Price Memo?`}</p>
          </div>
        }
        action={
          <>
          <ButtonComponent
            maxWidth="170px"
            label="No"
            bgColor="white"
            color="black"
            onClick={() => setOpenPublishPopup(false)}
          />
          <ButtonComponent
            maxWidth="170px"
            label="Yes"
            bgColor="black"
            color="white"
            onClick={publishPriceMemoHandler}
          />
          </>
        }
      />}
      {
        openDeletePopup &&
        <Modal
          open={openDeletePopup}
          handleClose={() => setOpenDeletePopup(false)}
          title="Delete Price Memo"
          content={
            <div>
              <p>{rowsData?.length > 1 ? `Are you sure you want to delete these Price Memos?` : `Are you sure you want to delete this Price Memo?`}</p>
            </div>
          }
          action={
            <>
            <ButtonComponent
              maxWidth="170px"
              label="No"
              bgColor="white"
              color="black"
              onClick={() => setOpenDeletePopup(false)}
            />
            <ButtonComponent
              maxWidth="170px"
              label="Yes"
              bgColor="black"
              color="white"
              onClick={deletePriceMemoHandler}
            />
            </>
          }
        />
      }
    </>
    
  )
}
